module.exports = __webpack_public_path__ + "static/media/property-purse-logo-white.72744f5f.svg";